import React from 'react';
export class ListItem extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const colorStyle = !this.props.disabled ? 'hover:text-white hover:bg-primary-800' : '';
            const cursorStyle = this.props.onClick ? 'cursor-pointer' : '';
            return (React.createElement(React.Fragment, null,
                React.createElement("li", { className: `${this.props.className} relative px-2 py-1 ${cursorStyle}`, style: this.props.style },
                    this.props.selected && (React.createElement("span", { className: 'absolute inset-y-0 left-0 w-1 bg-primary-600 rounded-tr-lg rounded-br-lg' })),
                    React.createElement("button", { disabled: this.props.disabled, onClick: this.props.onClick, className: `inline-flex items-center w-full px-2 py-2 text-sm font-semibold rounded ${colorStyle} transition-colors duration-150` },
                        this.props.icon,
                        React.createElement("span", { className: 'ml-4' }, this.props.label)))));
        };
    }
}
